import { ErrorCore } from '@components/error-core'

interface CollectionPageErrorProps {
  error: unknown
  info?: {
    componentStack: string
  }
}

export const CollectionPageError = ({
  error,
  info
}: CollectionPageErrorProps) => {
  return <ErrorCore error={error} info={info} />
}
